import React from "react";
import Stars from "theme/components/molecules/Stars";

const RatingAverage = ({ reviewsLayer, itemProp, size, noSeo }) => {
  if (noSeo) {
    return (
      <div>
        <Stars rating={reviewsLayer.ratingAverage} size={size} />
      </div>
    );
  }

  return (
    <div
      itemProp={itemProp}
      itemScope
      itemType="https://schema.org/AggregateRating"
    >
      <meta
        itemProp="ratingValue"
        content={reviewsLayer.ratingAverage.toFixed(1)}
      />
      <meta itemProp="bestRating" content="5" />
      <meta itemProp="ratingCount" content={reviewsLayer.total} />
      <Stars rating={reviewsLayer.ratingAverage} size={size} />
    </div>
  );
};

export default RatingAverage;
